import FormHelperText from "@mui/material/FormHelperText";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import { getIn, useField, useFormikContext } from "formik";
import { useEffect } from "react";
import { StyledFormikSelect } from "../../styled/FormikSelect";

const FormikSelect = (props) => {
  const [field, meta] = useField(props);
  const { values } = useFormikContext();
  const fieldValue = getIn(values, props.name);

  useEffect(() => {
    if (props.callback) {
      props.callback(fieldValue);
    }
  }, [fieldValue]);

  return (
    <StyledFormikSelect.FormControl
      error={meta.touched && meta.error ? true : false}
      disabled={props.disabled ? true : false}
      variant={props.variant ? props.variant : "standard"}
      {...props}
    >
      <InputLabel>{props.label}</InputLabel>
      <Select
        name={props.name}
        value={props.value}
        variant={props.variant}
        label={props.label}
        {...field}
      >
        {props.children}
      </Select>
      <FormHelperText>
        {meta.touched && meta.error ? meta.error : null}
      </FormHelperText>
    </StyledFormikSelect.FormControl>
  );
};

export default FormikSelect;
